module.exports = __webpack_public_path__ + "static/logos/logo-intersport--color-208ff4d895c4e61e1057f2c3a53458da.svg";